import { createTheme } from '@mui/material/styles';
const theme = createTheme({
    palette: {
        primary: {
            light: '#FF5166',
            main: '#FF5166',
            dark: '#FF5166',
            contrastText: '#fff',
        },
        secondary: {
            light: '#FF5166',
            main: '#FF5166',
            dark: '#FF5166',
            contrastText: '#000',
        },
    },
});
export default theme;